import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    backgroundColor: tokens.colorNeutralBackground1,
    height: "100vh",
  },
  main: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "stretch",
    ...shorthands.padding("24px", "0px", "20px", "0px"),
    ...shorthands.gap("6px"),
    backgroundColor: tokens.colorNeutralBackground1,
    "@media (min-width: 500px)": {
      height: "100%",
      alignItems: "stretch",
      backgroundColor: tokens.colorNeutralBackground2,
    },
  },
  subMainContainer: {
    display: "flex",
    flexDirection: "column",
    "@media (min-width: 500px)": {
      ...shorthands.padding("16px", "16px", "24px", "16px"),
      ...shorthands.borderRadius("8px"),
      backgroundColor: tokens.colorNeutralBackground1,
      boxShadow: tokens.shadow2,
      height: "100vh",
      ...shorthands.overflow("hidden"),
    },
    "@media (min-width: 500px) and (max-width: 899px)": {
      marginLeft: "40px",
      marginRight: "40px",
      maxWidth: "100%",
    },
    "@media (min-width: 900px) and (max-width: 1239px)": {
      ...shorthands.margin("0px", "auto"),
      width: "840px",
    },
    "@media (min-width: 1240px) and (max-width: 1399px)": {
      marginLeft: "200px",
      marginRight: "200px",
      maxWidth: "100%",
    },
    "@media (min-width: 1400px)": {
      ...shorthands.margin("0px", "auto"),
      width: "1040px",
    },
  },
});
